(() => {
  if (customElements.get('qs-card-submissions')) return;
  // Quantity exists only on the Shopify line, never inside descriptive properties.
  function makeItem(variant, quantity, properties) {
    if (!variant || variant.available !== 'true') throw new Error('Choose an available insured value.');
    const q = Number(quantity), min = Number(variant.min || 1), step = Number(variant.step || 1);
    if (!Number.isSafeInteger(q) || q < min || q % step !== 0 || (variant.max && q > Number(variant.max))) {
      throw new Error('Enter a valid whole-card quantity within the selected variant’s limits.');
    }
    return { id: Number(variant.variant), quantity: q, properties };
  }
  class CardSubmissions extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.rows = this.querySelector('[data-rows]');
      this.status = this.querySelector('[data-status]');
      this.services = [...this.querySelectorAll('[data-service]')].map(el => ({ title: el.dataset.title, variants: [...el.querySelectorAll('[data-variant]')].map(v => ({...v.dataset})) })).filter(s => s.variants.some(v => v.available === 'true'));
      this.money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:this.dataset.currency || 'EUR'}).format(value / 100);
      this.batch = crypto.randomUUID();
      this.querySelector('[data-add]').addEventListener('click', () => this.addRow(true));
      this.form.addEventListener('input', () => this.total());
      this.form.addEventListener('change', () => this.total());
      this.form.addEventListener('submit', e => { e.preventDefault(); this.submit(); });
      if (!this.services.length) { this.status.textContent = 'No grading services are available. Please contact us.'; this.querySelector('.qs-controls').disabled = true; return; }
      this.addRow();
    }
    addRow(focus = false) {
      const row = document.createElement('fieldset'); row.className = 'qs-card'; row.dataset.row = crypto.randomUUID();
      row.innerHTML = '<legend></legend><div class="qs-grid"></div><div class="qs-line-total"></div><button type="button" class="qs-remove">Remove card</button>';
      const grid = row.querySelector('.qs-grid');
      const field = (label, name, type, required = false) => {
        const wrapper = document.createElement('label'); wrapper.textContent = label;
        const input = document.createElement(type === 'select' ? 'select' : 'input'); input.name = name;
        if (type !== 'select') input.type = type;
        input.required = required; if (type === 'text') input.maxLength = 150;
        wrapper.append(input); grid.append(wrapper); return input;
      };
      const service = field('Grading service', 'service', 'select', true);
      this.services.forEach((s,i) => service.add(new Option(s.title, String(i))));
      service.parentElement.hidden = this.dataset.product === 'true';
      field('Year', 'Year', 'text');
      field('Product', 'Product / set', 'text', true);
      const cardName = field('Player or Card Name', 'Player or card name', 'text', true);
      cardName.parentElement.classList.add('qs-wide');
      field('Card #', 'Card number', 'text');
      field('Card Type', 'Card type', 'text');
      const quantity = field('Quantity', 'quantity', 'number', true); quantity.value = '1'; quantity.min = '1'; quantity.step = '1';
      const insured = field('Max insured value', 'insured', 'select', true);
      const insuranceField = document.createElement('div'); insuranceField.className = 'qs-insurance-field';
      const insuranceLabel = insured.parentElement;
      insuranceLabel.replaceWith(insuranceField);
      insured.id = `qs-insured-${row.dataset.row}`;
      insuranceLabel.htmlFor = insured.id;
      insuranceLabel.removeChild(insured);
      const heading = document.createElement('div'); heading.className = 'qs-insurance-heading';
      const help = document.createElement('button'); help.type = 'button'; help.className = 'qs-help'; help.textContent = '?';
      help.setAttribute('aria-label', 'About max insured value'); help.setAttribute('aria-expanded', 'false');
      const explanation = document.createElement('div'); explanation.className = 'qs-insurance-help'; explanation.hidden = true;
      explanation.id = `qs-insurance-help-${row.dataset.row}`;
      explanation.textContent = 'Select the maximum insured value per card, based on your estimate of its value after grading. Each additional € 100,- of coverage adds € 1.20 to the price per card.';
      help.setAttribute('aria-controls', explanation.id); insured.setAttribute('aria-describedby', explanation.id);
      const closeHelp = () => { explanation.hidden = true; help.setAttribute('aria-expanded', 'false'); };
      help.addEventListener('click', () => { explanation.hidden = !explanation.hidden; help.setAttribute('aria-expanded', String(!explanation.hidden)); });
      insuranceField.addEventListener('keydown', event => { if (event.key === 'Escape' && !explanation.hidden) { closeHelp(); help.focus(); event.stopPropagation(); } });
      insuranceField.addEventListener('focusout', event => { if (!insuranceField.contains(event.relatedTarget)) closeHelp(); });
      heading.append(insuranceLabel, help); insuranceField.append(heading, explanation, insured);
      const updateLimits = () => {
        const v = this.services[Number(service.value)].variants.find(v => v.variant === insured.value);
        quantity.min = v?.min || '1'; quantity.step = v?.step || '1';
        if (v?.max) quantity.max = v.max; else quantity.removeAttribute('max');
      };
      const updateVariants = () => {
        insured.replaceChildren(new Option('Select insured value', ''));
        this.services[Number(service.value)].variants.forEach(v => { const option = new Option(v.label,v.variant); option.disabled = v.available !== 'true'; insured.add(option); });
        updateLimits(); this.total();
      };
      service.addEventListener('change', updateVariants); insured.addEventListener('change', updateLimits);
      row.querySelector('.qs-remove').addEventListener('click', () => { row.remove(); this.total(); });
      this.rows.append(row); updateVariants(); this.total(); if (focus) service.focus();
    }
    collect(row) {
      const value = name => row.querySelector(`[name="${name}"]`).value.trim();
      const service = this.services[Number(value('service'))];
      const variant = service.variants.find(v => v.variant === value('insured'));
      const properties = { '_qs_submission': this.batch, '_qs_card_entry': row.dataset.row };
      ['Year','Product / set','Player or card name','Card number','Card type'].forEach(name => { if (value(name)) properties[name] = value(name); });
      if (!properties['Product / set'] || !properties['Player or card name']) throw new Error('Enter a product/set and card name for each card.');
      // The variant itself carries the authoritative insured-value selection.
      return {item:makeItem(variant, value('quantity'), properties), price:Number(variant.price)};
    }
    total() {
      let count = 0, amount = 0, complete = true;
      [...this.rows.children].forEach((row,i) => {
        row.querySelector('legend').textContent = `Card entry ${i+1}`;
        row.querySelector('.qs-remove').hidden = this.rows.children.length === 1;
        try { const {item,price} = this.collect(row); count += item.quantity; amount += item.quantity*price; row.querySelector('.qs-line-total').textContent = `${item.quantity} × ${this.money(price)} = ${this.money(item.quantity*price)}`; }
        catch { complete = false; row.querySelector('.qs-line-total').textContent = 'Complete this card to calculate its price.'; }
      });
      this.querySelector('[data-count]').textContent = `${count} card${count === 1 ? '' : 's'}${complete ? '' : ' · incomplete entries'}`;
      this.querySelector('[data-total]').textContent = this.money(amount);
    }
    async submit() {
      if (this.busy || !this.form.reportValidity()) return;
      let items;
      try { items = [...this.rows.children].map(row => this.collect(row).item); if (!items.length) throw new Error('Add a card first.'); }
      catch(e) { this.status.textContent = e.message; return; }
      this.busy = true; this.querySelector('.qs-controls').disabled = true; this.status.textContent = 'Adding your cards…';
      const root = this.dataset.root || '/';
      try {
        // One request: never silently submit only the first card or retry a POST.
        const response = await fetch(`${root}cart/add.js`, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Shopify could not add the submission.');
        const check = await fetch(`${root}cart.js`, {cache:'no-store'});
        if (!check.ok) throw new Error('The cart could not be verified.');
        const cart = await check.json();
        if (!items.every(expected => cart.items.some(actual => actual.variant_id === expected.id && actual.quantity === expected.quantity && actual.properties?._qs_submission === this.batch && actual.properties?._qs_card_entry === expected.properties._qs_card_entry))) throw new Error('The cart quantities need checking.');
        this.status.textContent = 'Your cards were added. Opening your cart…';
        window.location.assign(`${root}cart`);
      } catch(e) {
        // Shopify may have changed the cart even if the response was lost or rejected.
        // Keep this form locked to prevent accidental duplicate paid submissions.
        this.status.textContent = `${e.message} Review your cart before starting another submission to avoid duplicates.`;
        this.querySelector('[data-cart]').hidden = false;
      }
    }
  }
  customElements.define('qs-card-submissions', CardSubmissions);
})();
